import React from 'react';

export default function I18nBreak() {
  return <br />;
}
